export default "<notifier-container></notifier-container>\n";